import { css } from '@emotion/react';

import { semantic_colors, colors, text_styles } from '../../foundation';
import { SwitchSize } from './Switch';
import { buildCSSWithLength } from '../../styles';

export const switch_base_css = css`
  position: relative;
  display: inline-flex;
  vertical-align: top;
  align-items: center;
  border-radius: 20px;
  transition: background-color 0.1s linear;
  border: none;
  opacity: 1;
  cursor: pointer;
  color: ${semantic_colors.content.primary_inverse};
  ${text_styles.Caption_11_SemiBold};

  & > span {
    flex-grow: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &::after {
    position: absolute;
    content: '';
    background: ${colors.white};
    display: block;
    transition: width 0.1s linear, transform 0.1s linear;
  }

  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:focus {
    outline: 3px solid ${semantic_colors.tab_focus};
    box-shadow: none;
  }
  &:focus:not(:focus-visible) {
    outline: none;
  }
`;

export const getStyleByProps = ({
  size,
  checked,
  width,
  hasLabel,
}: {
  size: SwitchSize;
  checked: boolean;
  width?: number;
  hasLabel: boolean;
}) => {
  const SIZE_MAP = {
    large: {
      height: 32,
      width_with_label: 69,
      width_no_label: 52,
      toggle_size: 24,
      toggle_margin: 4,
    },
    medium: {
      height: 26,
      width_with_label: 64,
      width_no_label: 44,
      toggle_size: 20,
      toggle_margin: 3,
    },
    small: {
      height: 20,
      width_with_label: 60,
      width_no_label: 36,
      toggle_size: 14,
      toggle_margin: 3,
    },
  };
  const PADDING_TEXT_LEFT = 8;
  const TEXT_LINE_HEIGHT = 18;
  const GAP = 4;

  const size_info = SIZE_MAP[size] || SIZE_MAP.small;
  const padding_text_block = (size_info.height - TEXT_LINE_HEIGHT) / 2;
  const padding_text_right = GAP + size_info.toggle_size + size_info.toggle_margin;

  return css`
    height: ${size_info.height}px;
    ${buildCSSWithLength('width', width ? width : hasLabel ? size_info.width_with_label : size_info.width_no_label)}
    padding: ${checked
      ? `${padding_text_block}px ${padding_text_right}px ${padding_text_block}px ${PADDING_TEXT_LEFT}px`
      : `${padding_text_block}px ${PADDING_TEXT_LEFT}px ${padding_text_block}px ${padding_text_right}px`};
    line-height: inherit;
    background-color: ${checked ? `${semantic_colors.accent.primary}` : `${colors.gray250}`};

    &::after {
      top: ${size_info.toggle_margin}px;
      left: ${size_info.toggle_margin}px;
      width: ${size_info.toggle_size}px;
      height: ${size_info.toggle_size}px;
      border-radius: ${size_info.toggle_size / 2}px;
      transform: ${checked
        ? `translateX(${
            (width ? width : hasLabel ? size_info.width_with_label : size_info.width_no_label) -
            size_info.toggle_size -
            size_info.toggle_margin * 2
          }px)`
        : `translateX(0)`};
    }

    &:not(:disabled):active::after {
      width: ${size_info.toggle_size + size_info.toggle_margin}px;
      ${checked
        ? `transform: translateX(${
            (width ? width : hasLabel ? size_info.width_with_label : size_info.width_no_label) -
            size_info.toggle_size -
            size_info.toggle_margin * 2 -
            size_info.toggle_margin
          }px);`
        : ''}
    }
  `;
};
